/** Fixed emoji set for posts and chat. */
export const REACTION_EMOJIS = ["❤️", "🔥", "👏", "😂", "😮", "😢"];
export const DEFAULT_REACTION = "❤️";

export function normalizeReactionEmoji(raw, fallback = DEFAULT_REACTION) {
  const hasRaw = raw != null && String(raw).trim() !== "";
  const candidate = hasRaw ? String(raw).trim() : fallback;
  if (candidate == null) return null;
  if (REACTION_EMOJIS.includes(candidate)) return candidate;
  return fallback == null ? null : DEFAULT_REACTION;
}

/** Ordered chips for UI from a reactions map. */
export function reactionEntries(reactions) {
  const map = reactions && typeof reactions === "object" ? reactions : {};
  return REACTION_EMOJIS.filter((emoji) => Number(map[emoji]) > 0).map(
    (emoji) => ({ emoji, count: Number(map[emoji]) || 0 }),
  );
}

export function applyOptimisticReaction(prev, emoji) {
  const nextEmoji = normalizeReactionEmoji(emoji);
  const reactions = { ...(prev?.reactions || {}) };
  const prevMine = prev?.my_reaction || null;

  if (prevMine && reactions[prevMine]) {
    reactions[prevMine] = Math.max(0, Number(reactions[prevMine]) - 1);
    if (reactions[prevMine] === 0) delete reactions[prevMine];
  }

  let my_reaction = nextEmoji;
  if (prevMine === nextEmoji) {
    my_reaction = null;
  } else {
    reactions[nextEmoji] = (Number(reactions[nextEmoji]) || 0) + 1;
  }

  const likes_count = Object.values(reactions).reduce(
    (sum, n) => sum + (Number(n) || 0),
    0,
  );

  return {
    reactions,
    my_reaction,
    likes_count,
    liked_by_me: Boolean(my_reaction),
  };
}
